import './styles/variables.css';
import './styles/base.css';
import './styles/components.css';
import { TrueAlphaApp } from './ui/app';

const root = document.querySelector<HTMLElement>('#app');

if (!root) throw new Error('TrueAlpha application root was not found.');

new TrueAlphaApp(root);
